import { Box } from "theme-ui"
import { Link } from "react-router-dom"
import { InnerSubNav } from "components"
import { useState } from "react"
import { INav } from "@types"

// getting props from the SubNav component
export interface SubNavProps {
 nav: INav[]
}
export const SubNavbar = ({ nav }: SubNavProps) => {
 // state for opening of the navbar menu
 const [parentMenuIndex, setParentMenuIndex] = useState<number | null>(null)
 return (
  <>
   <Box color="text" bg="highlight" className="py-2 relative z-20">
    {nav.map((nav, index) => (
     <ul key={index} className="w-60">
      {/* ============ onMouseEnter-&-onMouseLeave for opening and closing of InnerSubMenu ======= */}
      {nav.name !== "" ? (
       <div
        onMouseEnter={() => {
         setParentMenuIndex(index)
        }}
        onMouseLeave={() => {
         setParentMenuIndex(null)
        }}
        className="flex relative  my-1 px-4 items-center justify-between"
       >
        <Link
         className={`cursor-pointer ${parentMenuIndex === index ? "text-yellow" : "color='text'"}`}
         to={"/" + nav.slug}
        >
         {nav.name}
        </Link>
        {/* ============== arrow-down togle when state gets true ============= */}
        {parentMenuIndex === index && nav?.slug === "" ? (
         <div className="cursor-pointer">
          <svg
           xmlns="http://www.w3.org/2000/svg"
           width="9"
           height="6"
           viewBox="0 0 9 6"
           fill="none"
          >
           <path
            d="M1.73506 4.56152L4.85776 1.43882L7.98047 4.56152"
            stroke="rgba(255, 184, 47, 2)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
           />
          </svg>
         </div>
        ) : (
         <div className="cursor-pointer">
          {nav?.slug === "" ? (
           <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
           >
            <path
             d="M8.22783 1.43848L5.10513 4.56118L1.98242 1.43848"
             strokeWidth="2"
             strokeLinecap="round"
             strokeLinejoin="round"
            />
           </svg>
          ) : (
           ""
          )}
         </div>
        )}
        {/* ============== InnerSubMenu opeining when state gets true ============= */}
        {parentMenuIndex === index && nav.slug === "" ? (
         <div className="absolute cursor-pointer top-0 right-[-10px]">
          <InnerSubNav nav={nav.subNav} />
         </div>
        ) : (
         ""
        )}
       </div>
      ) : (
       <div className="border-b"></div>
      )}
     </ul>
    ))}
   </Box>
  </>
 )
}
